import React from 'react';
import styled from 'styled-components';
import { Link } from '../../../routes';


import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';


const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
`;
const Content = styled(FlexBox)`
  max-width: 940px;
  padding: 0px 25px;
  margin: 0 auto;
  font-family: ${({ theme }) => theme.fontIBMBold};
`;
const TitleMax = styled.div`
    width: 100%;
    font-family: ${({ theme }) => theme.fontIBMBold};
    font-style: normal;
    font-weight: bold;
    font-size: 42px;
    ${({ hasLineHeight }) => (hasLineHeight ? 'margin-top:60px;' : 'line-height: 54px;')};
    color: #212833;
    ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top:60px;' : 'margin-top: 100px;')};
`;
const Details = styled.div`
    font-family: ${({ theme }) => theme.fontIBMBold};
    margin-top: ${({ theme }) => theme.fontSizeXxl};
    ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top: 5px;' : 'margin-top: 20px;')};
    ${({ hasMarginBottom }) => (hasMarginBottom ? 'margin-bottom: 100px;' : null)};
    >p{
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-style: normal;
    font-weight: normal;
    font-size: ${({ theme }) => theme.fontSizeXxl};
    line-height: 40px;
    color: #212833;
    margin:0px;
    }
    > .hasColor{
        font-style: normal;
        font-weight: normal;
        font-size: ${({ theme }) => theme.fontSizeXxl};
        line-height: 40px;
        color: #f0b90b;
    }
    > .hasColor:hover{
        text-decoration: underline;
    }
`;
type Props = {
    i18n: Object,
  };
export default
@withI18n
class Banner extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
  };

  render() {
    const { i18n } = this.props;

    return (
      <WrapperBox direction="column">
        <Content>
          <TitleMax>
            {getLabel('usExchange-aboutCenter-Participate', i18n,
              'Participate in an inclusive crypto ecosystem and access cutting-edge trading technology, built just for you.')}
          </TitleMax>
          <Details>
            <p>
              {getLabel('usExchange-aboutCenter-Launched', i18n)}
            </p>
          </Details>
          <TitleMax hasLineHeight="true" hasMarginTop="true">
            Career Opportunities
          </TitleMax>
          <Details hasMarginTop="true" hasMarginBottom="true">
            <Link route="https://jobs.lever.co/BAMTradingServices" prefetch={true}>
              <a className="hasColor" target="_blank">Binance.US Job Listings</a>
            </Link>
          </Details>
        </Content>
      </WrapperBox>
    );
  }
}
